"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createBEM = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }

function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }

var defaultConfig = {
  prefixCls: '',
  blockSeparator: '-',
  elementSeparator: '__',
  modifierSeparator: '--',
  modifierValueSeparator: '-'
};

var BEMClassName = function BEMClassName(name, config) {
  var elementSeparator = config.elementSeparator,
      modifierSeparator = config.modifierSeparator,
      modifierValueSeparator = config.modifierValueSeparator;
  return function (element, modifiers) {
    var _modifiers;

    if (element && typeof element !== 'string') {
      modifiers = element;
      element = '';
    }

    var newBlock = element ? name + elementSeparator + element : name;
    var classList = [newBlock];
    (_modifiers = modifiers) === null || _modifiers === void 0 ? void 0 : _modifiers.forEach(function (modifier) {
      var modifierType = (0, _typeof2["default"])(modifier);

      switch (modifierType) {
        case 'string':
          classList.push(modifier);
          break;

        case 'object':
          Object.entries(modifier || {}).forEach(function (_ref) {
            var _ref2 = (0, _slicedToArray2["default"])(_ref, 2),
                key = _ref2[0],
                value = _ref2[1];

            if (value === true) {
              classList.push(newBlock + modifierSeparator + key);
            } else if (value) {
              classList.push(newBlock + modifierSeparator + key + modifierValueSeparator + value);
            }
          });
          break;

        default:
          break;
      }
    });
    return classList.join(' ');
  };
};

var createBEM = function createBEM(name, config) {
  config = _objectSpread(_objectSpread({}, defaultConfig), config);
  var _config = config,
      prefixCls = _config.prefixCls,
      blockSeparator = _config.blockSeparator;
  var prefixedName = prefixCls ? prefixCls + blockSeparator + name : name;
  return BEMClassName(prefixedName, config);
};

exports.createBEM = createBEM;